import { Pipe, PipeTransform } from '@angular/core'
import { TerminologyId } from 'common/terminology'
import { TerminologyService } from '../terminology.service'

/**
 * Text written in a template, in the site's terminology
 * (common/terminology.ts): `{{ 'Select a Scanner' | term }}` reads "Select a
 * Unit" on a site using the Universal terminology. For literals only, never
 * for a name.
 *
 * Impure on purpose: the input is a literal that never changes, so a pure
 * pipe would keep the wording it computed first, and the sidebar lives for
 * the whole session. Angular gives each use of an impure pipe its own
 * instance, so remembering the last answer makes every later check one
 * comparison.
 */
@Pipe({
  name: 'term',
  pure: false,
})
export class TermPipe implements PipeTransform {
  private text?: string
  private terminology?: TerminologyId
  private result = ''

  constructor(private terms: TerminologyService) {}

  transform(text: string | null | undefined): string {
    if (text === null || text === undefined) {
      return ''
    }
    if (text !== this.text || this.terms.id !== this.terminology) {
      this.text = text
      this.terminology = this.terms.id
      this.result = this.terms.apply(text)
    }
    return this.result
  }
}
